import React from 'react';
import { motion } from 'framer-motion';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
};
type Pixel = (command: 'track', event: 'InitiateCheckout', data: {
  content_name: string;
  value: number;
  currency: string;
}) => void;
export function CheckoutButton({
  children,
  className = ''
}: ButtonProps) {
  function trackCheckout() {
    const pixel = (window as Window & {
      fbq?: Pixel;
    }).fbq;
    pixel?.('track', 'InitiateCheckout', {
      content_name: 'Dance Fitness Instructor Pro Complete Teaching System',
      value: 27,
      currency: 'USD'
    });
  }
  return <motion.a href="https://dance-fitness-instructor-pro.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" onClick={trackCheckout} whileHover={{
    scale: 1.025
  }} whileTap={{
    scale: 0.98
  }} className={`inline-flex min-h-12 items-center justify-center rounded-full border border-gold-light/60 bg-gold px-7 py-3.5 text-center text-sm font-bold tracking-wide text-black shadow-[0_10px_28px_rgba(212,175,55,.24)] transition-colors hover:bg-gold-light focus:outline-none focus:ring-2 focus:ring-gold-light focus:ring-offset-2 focus:ring-offset-charcoal sm:px-9 sm:text-base ${className}`} data-id="element-38">
      {children}
    </motion.a>;
}